import { useEffect, useState } from "react";
import { Badge, CircularProgress, Grid, IconButton,Typography } from "@mui/material";
import { Save as SaveIcon, Edit as EditIcon, Delete as DeleteIcon, ArrowUpward as ArrowUpwardIcon, ArrowDownward as ArrowDownwardIcon, Add as AddIcon, List as ListIcon } from "@mui/icons-material";
import { useMutation } from "react-query";
import { useFieldArray, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { ValidationSchemaFloors } from "../services/SchemaValidation";
import FullScreenDialog from "components/Dialog/FullScreenDialog";
import ImageGalleryCard from "components/Card/ImageLeftCard";
import { editProductFloors } from "services/api/Product";
import Add from "./Add";
import Edit from "./Edit";
import Features from "./Features";
import Remove from "./Remove";

export default function Floor({ open, close, instance, reportAction }) {
  const [isLoading, setIsLoading] = useState(false);
  const [openAction, setOpenAction] = useState(0) // 0: close, 1: add, 2: edit, 3: delete
  const [position, setPosition] = useState(null)
  const [instanceSelected, setInstanceSelected] = useState({})
    let { /*handleSubmit: hTBP, formState: { errors: eTBP },*/ control: cTBP, setValue: svTBP, getValues } = useForm({ 
    resolver: yupResolver(ValidationSchemaFloors), 
    defaultValues: { 'floors': [] } 
  }) // useForm para array de floors
  const {fields: fTBP, append: aTBP, remove: rmvTBP, update: updTBP, move: mvTBP} = useFieldArray({ 
    name: 'floors', control: cTBP 
  }) // useFieldArray para administrar campo de floors (array) de Products

  useEffect(() => { if (open) { svTBP('floors', instance.floors) } }, [open])

  const mutation = useMutation(editProductFloors, {
    onSuccess: (data) => {
      setIsLoading(false)
      if(data.status === "error") { 
        reportAction('floor', false, { message: 'Error al editar los datos'}, false)
      } else { 
        reportAction('floor', false, { }, true) 
      }
    }
  })

  const onSubmit = () => { //console.log("onSubmit", fTBP) 
    setIsLoading(true)
    mutation.mutate({ id: instance._id, params: fTBP })
  }

  const handleClose = () => {  close(); }

  const handleAddFloor = (data) => { aTBP(data) }
  const handleLoadEditFloor = (position, data) => {
    setPosition(position)
    setInstanceSelected(data)
  }
  const handleEditFloor = (data) => { 
    let dataTemp = { ...fTBP[position], name: data.name }
    updTBP(position, dataTemp) 
  }
  const handleLoadRemoveFloor = (position, data) => {
    setPosition(position)
    setInstanceSelected(data)
  }
  const handleRemoveFloor = () => { rmvTBP(position) }
  const handlerChangePositionFloor = (direction, position) => { mvTBP(position, direction === 'up' ? position - 1 : position + 1) }

  const handleEditFloorFeatures = (data) => { 
    let dataTemp = { ...fTBP[position], features: data }
    updTBP(position, dataTemp) 
  }

  const Actions = ({ item, index, totalItems, totalFeatures }) => ( <>
    <IconButton aria-label="edit" onClick={ () => { handleLoadEditFloor(index, item); setOpenAction(2) }  }> <EditIcon color="info"/> </IconButton>
    <IconButton aria-label="delete" onClick={ () => { handleLoadRemoveFloor(index, item); setOpenAction(3) } }> <DeleteIcon color='error'/> </IconButton>
    <IconButton aria-label="features" onClick={ () => { handleLoadEditFloor(index, item); setOpenAction(4) }}> <Badge badgeContent={totalFeatures} color="primary"><ListIcon color='success'/></Badge> </IconButton>
    <div>
    {index !== 0 && <IconButton aria-label="up-position" onClick={ () => handlerChangePositionFloor("up", index) }> <ArrowUpwardIcon /> </IconButton>}
    {index !== totalItems - 1 && <IconButton aria-label="down-position" onClick={ () => handlerChangePositionFloor("down", index) }> <ArrowDownwardIcon /> </IconButton> }
    </div>
  </> )

  /* Drag and Drop */
  const handleDrop = (droppedItem) => {
    if (!droppedItem.destination) return;
    var updatedList = getValues("floors");
    const [reorderedItem] = updatedList.splice(droppedItem.source.index, 1);
    updatedList.splice(droppedItem.destination.index, 0, reorderedItem);
    svTBP('floors', updatedList)
  }
 
  return ( <>
    <FullScreenDialog open={ open } changeOpen={ handleClose } title={`Pisos - ${instance.name}`} actions={ <>
      { !isLoading ? <>
        <IconButton autoFocus color="inherit" onClick={ () => setOpenAction(1) } aria-label="add"> <AddIcon /> </IconButton> 
        <IconButton autoFocus color="inherit" onClick={ onSubmit } aria-label="save"> <SaveIcon /> </IconButton>
      </> : <CircularProgress /> }
    </> }>
      <div className="admin-image-gallery one-columns">
        <div className="list-container">
          {/* <div style={{ width: "200px" }}><pre>{JSON.stringify(fTBP, undefined, 2)}</pre></div> */}
          <DragDropContext onDragEnd={handleDrop}>
            <Droppable droppableId="droppable">
              { (provided) => (
                <Grid container spacing={2} className="droppable" {...provided.droppableProps} ref={provided.innerRef}>
                { (fTBP.length > 0) ? (
                fTBP.map((item, i) => (
                  <Draggable key={item.id} draggableId={item.id} index={i}>
                    {(provided) => (
                      <Grid item xs={12} ref={provided.innerRef} {...provided.dragHandleProps} {...provided.draggableProps}>
                        <ImageGalleryCard 
                          image={item.image} 
                          description={item.name} 
                          actions={ 
                            <Actions item={ item } index={ i } totalItems={ fTBP.length } 
                              totalFeatures={item.features ? item.features.length : 0}
                            /> 
                          }
                        />
                      </Grid>
                    )}
                  </Draggable>
                )) ) : <Grid item xs={12}> <Typography variant="inherit">No hay pisos agregados</Typography> </Grid> }
                </Grid>
              ) }
            </Droppable>
          </DragDropContext>
        </div>
      </div>
    </FullScreenDialog>
    <Add open={ openAction === 1 } close={ () => setOpenAction(0) } action={ handleAddFloor } />
    <Edit open={ openAction === 2 } close={ () => setOpenAction(0) } instance={ instanceSelected } action={ handleEditFloor } />
    <Remove open={ openAction === 3 } close={ () => setOpenAction(0) } instance={ instanceSelected } action={ handleRemoveFloor } />
    <Features open={ openAction === 4 } close={ () => setOpenAction(0) } rsdId={ instance._id } instance={ instanceSelected } action={ handleEditFloorFeatures } />
  </> )
}